import $ from 'jquery'

function init() {
    setUpEventListeners()
}

function setUpEventListeners() {
    $(window).on('load', events.onWindowLoad)
    $(window).on('resize', events.onWindowResize)

    if (document.readyState.toLowerCase() === 'complete') {
        events.onWindowLoad()
    }
}

function postContentHeightToParent() {
    const content_height = $('body').outerHeight()

    window.parent.postMessage(content_height, '*')
}

const events = {
    onWindowLoad() {
        postContentHeightToParent()
    },
    onWindowResize() {
        postContentHeightToParent()
    }
}

export default { 
    init,
    postContentHeightToParent
}